export const EXPERIMENTS = Object.freeze({
  GDPR_PLACING: 'gdpr_placing',
})

export const EXPERIMENT_VARIANTS = Object.freeze({
  [EXPERIMENTS.GDPR_PLACING]: {
    CONTROL: 'control',
    VARIANT_A: 'variant_A',
  },
})
